<template>
  <v-dialog v-model="dialog" max-width="350">
    <v-card>
      <v-card-title class="headline">¿Cerrar sesión?</v-card-title>
      <v-card-text>
        <p>¿Estás seguro de que deseas cerrar sesión?</p>
      </v-card-text>
      <v-card-actions>
        <CancelButton @click="dialog = false"/>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            @click="logout"
        >
          <v-icon left>mdi-logout</v-icon>
          Cerrar sesión
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import CancelButton from "@/components/buttons/CancelButton.vue";

export default Vue.extend({
  name: "DialogLogout",
  components: {CancelButton},
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/inicio-de-sesion");
    },
  },
});
</script>
